import {
    MULTIPLE_ITEMS_TOAST_MESSAGE_FORMAT,
    SINGLE_ITEM_TOAST_MESSAGE_FORMAT,
} from "@checkout-core/constants/GroupCart";
import { CartItem, GetGroupCartOrderResponse, UsersOrderMap } from "@swiggy-private/cart-types";
import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { format, isEmpty } from "@swiggy-private/js-utils";
import { GlobalHeaderState } from "@checkout-core/utils";

// Helper function to create a map of item hashes for quick lookup
export const createItemHashLookup = (userCart: CartItem[]): Record<string, number> => {
    const lookup: Record<string, number> = {};
    userCart.forEach(item => {
        lookup[item.menu_item_id] = item.quantity;
    });
    return lookup;
};

export const getDiffItemsStr = (
    oldCartData?: GetGroupCartOrderResponse["data"],
    newCartData?: GetGroupCartOrderResponse["data"],
): string | undefined => {
    const skipCheckingDiff = isEmpty(oldCartData) || isEmpty(newCartData);

    if (skipCheckingDiff) return;

    const oldCartMapState = oldCartData?.user_cart_map as UsersOrderMap;
    const newCartMapState = newCartData?.user_cart_map as UsersOrderMap;

    const currentUserId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.userId);
    const newItemsAddedMap: { [itemName: string]: number } = {};
    let totalLen = 0;

    // Iterate over each user in the new cart map
    Object.keys(newCartMapState).forEach(userId => {
        if (userId === currentUserId) return;

        const newUserCart = newCartMapState[userId]?.user_cart || [];
        const oldUserCart = oldCartMapState[userId]?.user_cart || [];
        const oldItemsLookup = createItemHashLookup(oldUserCart);

        // Check each item in the new user cart to see if it exists in the old cart
        newUserCart.forEach((item: CartItem) => {
            const currentQuantity = item.quantity;
            if (oldItemsLookup[item.menu_item_id] < currentQuantity) {
                // If the item is not found in the old cart, add its name to the result array
                newItemsAddedMap[item.name] = currentQuantity - oldItemsLookup[item.menu_item_id];
                totalLen += currentQuantity - oldItemsLookup[item.menu_item_id];
            }
        });
    });

    // Handling single and multiple diff items
    if (totalLen <= 0) {
        return "";
    } else if (totalLen == 1) {
        const singleItemValue = format(SINGLE_ITEM_TOAST_MESSAGE_FORMAT, Object.keys(newItemsAddedMap)[0]);
        return singleItemValue;
    }

    const multipleItemValue = format(
        MULTIPLE_ITEMS_TOAST_MESSAGE_FORMAT,
        Object.keys(newItemsAddedMap)[0],
        totalLen - 1,
    );
    return multipleItemValue;
};
